module.exports = __webpack_public_path__ + "img/section1.6f92e6e3.png";